module.exports = __webpack_public_path__ + "static/media/logo-with-text.002bf0f0.svg";